const chat_styles = {
  
  /* fontFamily: 'Helvetica Neue',
  headerBgColor: '#3333ff',
  headerFontColor: '#fff',
  headerFontFamily: 'Montseratt',
  botBubbleColor: '#3333ff',
  botFontColor: '#fff',
  userBubbleColor: '#fff',
  userFontColor: '#4a4a4a',
 */
 
    background: '#FFECF8',
    headerBgColor: '#FF8CD3',
    headerFontColor: '#fff',
    headerFontSize: '20px',
    botBubbleColor: '#FFC6E9',
    botFontColor: 'black',
    userBubbleColor: '#C2F4F6',
    userFontColor: 'black',

};

export default chat_styles;
